module.exports = __webpack_public_path__ + "static/media/unity.81fbf07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/unity.png
// module id = 94
// module chunks = 0